document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwiper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwiper[i] = swiper;

    });

    let topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    let sliderQuad = new Swiper('.slider__slider',{
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        }
    });

    let quadReviews = new Swiper('.reviews__slider',{
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        },
        breakpoints: {
            1024: {
                slidesPerView: 2
            }
        }
    });

    let gallerySliderExtra = new Swiper('.gallery-slider__extra-one',{
        speed: 1000,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        effect: 'fade',
            fadeEffect: {
            crossFade: true
        }
    });

    let gallerySliderExtraTwo = new Swiper('.gallery-slider__extra-two',{
        speed: 1000,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        effect: 'fade',
            fadeEffect: {
            crossFade: true
        }
    });

    let gallerySlider = new Swiper('.gallery-slider__slider',{
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-slider-prev',
            nextEl: '.gallery-slider-next'
        }
    });

    if(document.querySelector('.gallery-slider__extra-one') || document.querySelector('.gallery-slider__extra-two')){
        gallerySlider.controller.control = [gallerySliderExtra, gallerySliderExtraTwo];
    }

    document.querySelectorAll('.rooms-quad__slider').forEach((element, i) => {
        let entryId = element.getAttribute('data-entry');
        element.setAttribute(`data-room-swiper-${i}`, "");
        let swiper = new Swiper(`[data-room-swiper-${i}]`,{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: `.room-${entryId}-prev`,
                nextEl: `.room-${entryId}-next`
            }
        });
    });

    let sliderEventsQuad = new Swiper('.slider-events__slider',{
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-events-prev',
            nextEl: '.slider-events-next'
        }
    });
});